import ButtonContent from './ButtonContent';

export default ButtonContent;
